export default {
      id: "ic-misc-contact-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic-misc-contact-usage",
      toString: function () {
        return this.url;
      }
    }